export const domain = (process.env.NODE_ENV === 'development' ? 'https://yjdev.xkw.com' : location.origin) + '/api'
export const redirectDomain = '' // 网络阅卷跳转区域域名
export const wechatKey = 'examReport'
